// removed by extract-text-webpack-plugin
module.exports = {"futureImageItem":"src-components-TeamNew-FollowUsSection-components-Section----styles-module---futureImageItem---UN0gK","vcenter":"src-components-TeamNew-FollowUsSection-components-Section----styles-module---vcenter---3ihNX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TeamNew/FollowUsSection/components/Section/styles.module.scss
// module id = 1870
// module chunks = 165990460456080